import React from 'react'

const ContactForm = () => {

  const handleSubmit = async (e) => {
    e.preventDefault()
        const url = "https://script.google.com/macros/s/AKfycbyD-BiUHq-oHyNntOKmyHcEkzvocq0piwRI1kzP6pAiyoyyPBzesMTOZr0-toHjey7s/exec"
        fetch(url, {
            method: "POST",
            headers: {"content-Type": "application/x-www-form-urlencoded"},
            body: (`firstName=${e.target.firstName.value}&lastName=${e.target.lastName.value}&email=${e.target.email.value}&phone=${e.target.phone.value}&message=${e.target.message.value}`)
        }).then(res=>res.text()).then(data=>{
            alert(data)
        }).catch(error=> {
          alert("Something went wrong. Please try again.");
        })
  }
  return (
    <>
      <form onSubmit={handleSubmit}>

        <div className="row mb-3">
          <div className="col-md-6 mb-3 mb-md-0">
            <label className="form-label fw-bold">First Name *</label>
            <input type="text" className="form-control" id="firstName" required />
          </div>

          <div className="col-md-6">
            <label className="form-label fw-bold">Last Name *</label>
            <input type="text" className="form-control" id="lastName" required />
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Email *</label>
          <input type="email" className="form-control" id="email"  required />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Phone</label>
          <input type="tel" className="form-control" id="phone" />
        </div>

        <div className="mb-4">
          <label className="form-label fw-bold">Message *</label>
          <textarea className="form-control" id="message" rows="5" />
        </div>

        <div className="d-grid">
          <button type="submit" className="btn btn-primary btn-lg fw-bold">Submit</button>
        </div>
      </form>

      <div className="mt-2 text-center">
        <p className="text-muted mb-0">
          <small>
            <i className="bi bi-shield-check text-primary me-1"></i>
            We respect your privacy and will never share your information
          </small>
        </p>
      </div>
    </>
  )
}

export default ContactForm